export const MENTO_LOGO_URL =
  'https://mento-space.nyc3.cdn.digitaloceanspaces.com/logo.svg';

export const DAY_HEADERS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'] as const;
export const COMFORTABLE_DAY_HEADERS = [
  'SUN',
  'MON',
  'TUE',
  'WED',
  'THU',
  'FRI',
  'SAT',
] as const;
export const DAY_HEADER_LABELS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const;

// Canonical Mento Rescheduling & Cancelation Policy (source: backend
// app/models/cal/cal_booking.rb). Same document the design labels
// "Scheduling & Cancellation Policy".
export const SCHEDULING_CANCELLATION_POLICY_URL =
  'https://mentoteam.notion.site/Mento-Rescheduling-Cancelation-Policy-ea6ed8fa23fc41a8a4598070ef42fb53';
export const BIWEEKLY_DESCRIPTION =
  'Choose a time that works for you every two weeks.';
